import {
  Alert,
  AlertProps,
  AlertTitle,
  CloseButton,
  Flex,
  useToast as useToastC,
} from '@chakra-ui/react';
import { useCallback } from 'react';

const defaultSx = { colorScheme: 'gray', bgColor: 'gray.50' };
const errorSx = { borderColor: 'red.500', bgColor: 'red.50' };

export const useSessionToast = () => {
  const toastFn = useToastC();

  const toast = useCallback(
    (msg: string, type?: AlertProps['status']) => {
      toastFn({
        position: 'bottom',
        render: () => (
          <Alert
            status={type}
            py={3}
            px={4}
            sx={type === undefined ? defaultSx : type === 'error' ? errorSx : undefined}
          >
            <Flex w="full" alignItems="center" justifyContent="space-between">
              <AlertTitle fontSize="sm">{msg}</AlertTitle>
              <CloseButton
                onClick={() => toastFn.closeAll()}
                bgColor="transparent"
                h="auto"
                _hover={{ bgColor: 'transparent' }}
              />
            </Flex>
          </Alert>
        ),
      });
    },
    [toastFn],
  );

  return toast;
};
